<template>
  <div>
    <div>
      <div :class="$style.flex">
        <BaseText>{{ $t('global.logo') }}</BaseText>
        <BaseToggle
          v-model="hasLogo"
          :disabled="!company.logo"
          v-test="'toggleLogo'"
        />
      </div>
      <div
        v-if="!company.logo"
        :class="$style.missingLogo"
      >
        <BaseAlert
          color="info"
          size="s"
          :text="$t('marketing.email.sections.logo_missing')"
          v-test="'missingLogoText'"
        />
      </div>
    </div>
    <div :class="$style.banner">
      <div :class="$style.flex">
        <BaseText>
          {{ $t('global.image') }}
          <BaseIcon
            :tooltip="$t('marketing.email.sections.image_size')"
            inline
            size="s"
            name="info"
          />
        </BaseText>
        <BaseToggle
          v-model="hasImage"
          v-test="'toggleBanner'"
        />
      </div>
      <Flex
        direction="column"
        v-show="hasImage"
      >
        <MessageField
          v-show="hasImageUrl"
          v-test="'bannerMessage'"
        >
          <div :class="$style.message">
            <BaseText>{{ imageStatus }}</BaseText>
            <BaseIcon
              name="delete"
              color="primary"
              @click="onDelete"
            />
          </div>
        </MessageField>
        <MessageField
          v-show="showError"
          danger
          v-test="'bannerError'"
        >
          <BaseText>{{ $t('global.image_upload_fail') }}</BaseText>
          <BaseText size="s">
            {{ $t('global.image_format_not_supported') }}
          </BaseText>
        </MessageField>
        <BaseUpload
          :hasImage="hasImageUrl"
          preset="marketing_newsletter"
          @uploadResults="onUpload"
          @error="onError"
        />
      </Flex>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState, storeToRefs } from 'pinia';
import { defineComponent } from 'vue';
import { modal } from '@/helpers/ui';
import { useCompanyStore } from '@/stores/company';
import { useMarketingStore } from '../../store';
import MessageField from './MessageField.vue';

export default defineComponent({
  components: {
    MessageField,
  },
  data() {
    return {
      showError: false,
    };
  },
  setup() {
    const { hasLogo, hasImage, imageUrl, defaultImageUrl } = storeToRefs(
      useMarketingStore(),
    );
    return {
      hasLogo,
      hasImage,
      imageUrl,
      defaultImageUrl,
    };
  },
  computed: {
    ...mapState(useCompanyStore, ['company']),
    imageStatus() {
      return this.$t('global.image_uploaded');
    },
    hasImageUrl() {
      return !!this.imageUrl && this.imageUrl !== this.defaultImageUrl;
    },
  },
  methods: {
    onUpload(result) {
      this.showError = false;
      this.imageUrl = result.url;
    },
    onDelete() {
      modal('confirmation', {
        type: 'delete',
        item: this.$t('global.items.image'),
      }).then(() => {
        this.imageUrl = this.defaultImageUrl;
      });
    },
    onError() {
      this.showError = true;
    },
  },
  created() {
    if (!this.company.logo) {
      this.hasLogo = false;
    }
  },
});
</script>

<style
  lang="scss"
  module
>
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: $spacing;
}

.banner {
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
  padding: $spacing 0;
  margin-bottom: $spacing;
}

.message {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.missingLogo {
  padding-bottom: $spacing;
}
</style>
